import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              最新文章
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              精彩内容解读与观影指南
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {articles.slice(0, 4).map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-48 h-48 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col justify-between flex-1">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-400 line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span className="flex items-center gap-1">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-eye-line"></i>
                    </span>
                    {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}